import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "usability"
    }}>{`Usability`}</h1>
    <p>{`Follow these guidelines to make sure that your add-on meets our usability standards before submitting.`}</p>
    <h2 {...{
      "id": "blending-with-adobe-express-ui"
    }}>{`Blending with Adobe Express UI`}</h2>
    <p>{`The add-on should integrate seamlessly with Adobe Express UI, incorporating commonly-used patterns within the Adobe Express UI to facilitate user navigation.`}</p>
    <p>{`We also suggest that you use the `}<a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/theming/#Resources-for-Spectrum-for-Adobe-Express"
      }}>{`Adobe Spectrum theme for Adobe Express`}</a>{`. It is not mandatory to use `}<a parentName="p" {...{
        "href": "https://spectrum.adobe.com/"
      }}>{`Adobe’s Spectrum libraries`}</a>{` for your add-on, but it can significantly simplify the development process.`}</p>
    <h2 {...{
      "id": "responsive-interface"
    }}>{`Responsive interface`}</h2>
    <p>{`You must make sure that your add-on’s user interface and controls are responsive, functional and usable across different browsers and screen sizes.`}</p>
    <h2 {...{
      "id": "user-inputs"
    }}>{`User inputs`}</h2>
    <p>{`The add-on must provide some sort of response or validation for user inputs, such as confirmation messages for successful actions or error messages for invalid inputs.`}</p>
    <h2 {...{
      "id": "error-messages"
    }}>{`Error messages`}</h2>
    <p>{`Any error messages, warnings or notifications should be clear, informative and helpful to the user.`}</p>
    <h2 {...{
      "id": "modal-dialogs"
    }}>{`Modal dialogs`}</h2>
    <p>{`The add-on should not interrupt the user’s workflow unnecessarily with dialog boxes. These boxes should only be used for important messages. Messages such as "success" notifications should be rendered inside the add-on’s UI panel instead.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      